import * as React from "react";
import * as Mui from "@mui/material";

export const PANEL_GRADIENT =
  "radial-gradient(120% 90% at 85% 8%, rgba(111,224,168,.18), transparent 55%), radial-gradient(90% 70% at 10% 100%, rgba(8,40,28,.55), transparent 60%), linear-gradient(155deg, #176B49 0%, #11503A 42%, #0B3B2A 100%)";

export const PANEL_GLOW =
  "radial-gradient(60% 50% at 75% 0%, rgba(255,255,255,0.07), transparent 70%)";

export const AuthLayout = ({ children }) => (
  <Mui.Grid
    container
    className="login-page"
    sx={{
      minHeight: "100vh",
      width: "100%",
      maxWidth: "100vw",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}
  >
    {children}
  </Mui.Grid>
);

export const AuthLeftPanel = ({ top, bottom }) => (
  <Mui.Grid
    item
    xs={0}
    sm={0}
    md={6}
    lg={6}
    sx={{
      minHeight: "100vh",
      display: { xs: "none", md: "flex" },
      minWidth: 0,
      position: "relative",
      overflow: "hidden",
      background: PANEL_GRADIENT,
      color: "#fff",
      px: { md: 6, lg: 8, xl: 10 },
      py: { md: 6, lg: 7 },
      flexDirection: "column",
    }}
  >
    <Mui.Box
      sx={{
        position: "absolute",
        inset: 0,
        background: PANEL_GLOW,
        pointerEvents: "none",
      }}
    />
    <Mui.Stack
      sx={{
        position: "relative",
        zIndex: 1,
        height: "100%",
        justifyContent: bottom ? "space-between" : "center",
      }}
    >
      {top}
      {bottom}
    </Mui.Stack>
  </Mui.Grid>
);

export const AuthRightPanel = ({ children }) => (
  <Mui.Grid
    item
    xs={12}
    sm={12}
    md={6}
    lg={6}
    sx={{
      minHeight: "100vh",
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#F4F5F4",
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 5, md: 4 },
    }}
  >
    {children}
  </Mui.Grid>
);

export const AuthCard = ({ children, maxWidth, sx }) => (
  <Mui.Box
    sx={{
      width: "100%",
      maxWidth: maxWidth || { xs: "100%", sm: 480, md: 440, lg: 500, xl: 540 },
      bgcolor: "#fff",
      borderRadius: "24px",
      border: "1px solid rgba(21,23,26,0.06)",
      boxShadow: "0 24px 60px rgba(15,40,30,0.10)",
      px: { xs: 3, sm: 5 },
      py: { xs: 4, sm: 5 },
      boxSizing: "border-box",
      ...sx,
    }}
  >
    {children}
  </Mui.Box>
);

export const FeatureTimeline = ({ items }) => (
  <Mui.Stack spacing={0} sx={{ maxWidth: 460 }}>
    {items.map((item, index) => (
      <Mui.Box
        key={item.title}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2.5,
          position: "relative",
        }}
      >
        <Mui.Box sx={{ position: "relative", flexShrink: 0 }}>
          {index < items.length - 1 ? (
            <Mui.Box
              sx={{
                position: "absolute",
                top: 54,
                left: "50%",
                transform: "translateX(-50%)",
                width: 0,
                height: 24,
                borderLeft: "2px dashed rgba(255,255,255,0.25)",
              }}
            />
          ) : null}
          <Mui.Box
            sx={{
              width: 54,
              height: 54,
              borderRadius: "14px",
              border: "1px solid rgba(255,255,255,0.14)",
              background: "rgba(255,255,255,0.06)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6FE0A8",
            }}
          >
            {item.icon}
          </Mui.Box>
        </Mui.Box>
        <Mui.Box sx={{ pt: 0.5, pb: 3 }}>
          <Mui.Typography sx={{ fontSize: 17, fontWeight: 700, color: "#fff" }}>
            {item.title}
          </Mui.Typography>
          <Mui.Typography
            sx={{
              mt: 0.5,
              fontSize: 14.5,
              lineHeight: 1.4,
              color: "rgba(255,255,255,0.58)",
            }}
          >
            {item.subtitle}
          </Mui.Typography>
        </Mui.Box>
      </Mui.Box>
    ))}
  </Mui.Stack>
);
